type IconProps = React.ComponentProps<'svg'>

export function Microphone01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 1.25)">
        <path
          d="M14.75 8C15.1642 8 15.5 8.33579 15.5 8.75V10.75C15.5 14.7772 12.4282 18.0856 8.5 18.4629V20H11.75C12.1642 20 12.5 20.3358 12.5 20.75C12.5 21.1642 12.1642 21.5 11.75 21.5H3.75C3.33579 21.5 3 21.1642 3 20.75C3 20.3358 3.33579 20 3.75 20H7V18.4629C3.07176 18.0856 0 14.7772 0 10.75V8.75C0 8.33579 0.335786 8 0.75 8C1.16421 8 1.5 8.33579 1.5 8.75V10.75C1.5 14.2018 4.29822 17 7.75 17C11.2018 17 14 14.2018 14 10.75V8.75C14 8.33579 14.3358 8 14.75 8Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.75 0C9.82107 0 11.5 1.67893 11.5 3.75V10.75C11.5 12.8211 9.82107 14.5 7.75 14.5C5.67893 14.5 4 12.8211 4 10.75V3.75C4 1.67893 5.67893 0 7.75 0ZM7.75 1.5C6.50736 1.5 5.5 2.50736 5.5 3.75V10.75C5.5 11.9926 6.50736 13 7.75 13C8.99264 13 10 11.9926 10 10.75V3.75C10 2.50736 8.99264 1.5 7.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
